import classnames from 'classnames'

import Button from '@components/Button'
import { CardSection } from '@components/CardSection'

import { PURCHASE_FLOW } from 'purchase-flow/constants'
import purchaseStyles from 'purchase-flow/styles.module.scss'

import styles from './styles.module.scss'

const PurchaseFlowHeader = ({
    activeStep,
    stepValues,
    location,
    translate: t,
    onStepClick,
    flowSteps = PURCHASE_FLOW,
}) => (
    <CardSection className={purchaseStyles.progressSection} loading={false}>
        <div className={classnames('d-flex', 'justify-content-between', 'align-items-start')}>
            <span className={classnames(purchaseStyles.location, 'd-flex')}>{location}</span>
            <Button btnStyle="link" onClick={() => window.location.href('/')}>
                <Link to="/">
                    <T>subscription.purchase.label.back.home</T>
                </Link>
            </Button>
        </div>
        <div className="d-flex">
            {flowSteps.map((step, index) => (
                <div
                    key={index}
                    className={classnames(styles.progressStep, {
                        [styles.active]: activeStep === step,
                        [styles.disabled]: index > PURCHASE_FLOW.indexOf(activeStep),
                    })}
                    onClick={() => index < PURCHASE_FLOW.indexOf(activeStep) && onStepClick(step)}>
                    <div className={styles.stepDescription}>
                        <span className={classnames(styles.stepNumber)}>{index + 1}</span>
                        <span className={styles.stepName}>{t(`subscription.purchase.${step}`)}</span>
                    </div>
                    {stepValues[step] && (
                        <div className={classnames('mb-3', styles.stepValue)}>{stepValues[step].displayValue}</div>
                    )}
                </div>
            ))}
        </div>
    </CardSection>
)

export default withTranslate(PurchaseFlowHeader)
